<ng-container *transloco="let t">
  <div class="d-flex align-items-center justify-content-center">
    <div class="py-4">
      <div class="pt-4">
        <div class="modal-title text-uppercase fw-bold">{{ title }}</div>
      </div>
      <div class="d-flex justify-content-between align-items-center pt-2" style="width: 1296px;">
        <div class="d-flex justify-content-between align-items-center">
          <button (click)="cropper?.zoomIn()" ly-button appearance="icon" [disabled]="!ready">
            <ly-icon>zoom_in</ly-icon>
          </button>
          <button (click)="cropper?.zoomOut()" ly-button appearance="icon" [disabled]="!ready">
            <ly-icon>zoom_out</ly-icon>
          </button>
          <button (click)="cropper?.center()" ly-button appearance="icon" [disabled]="!ready">
            <ly-icon>filter_center_focus</ly-icon>
          </button>
          <button (click)="cropper?.rotate(-90)" ly-button appearance="icon" [disabled]="!ready">
            <ly-icon>rotate_90_degrees_ccw</ly-icon>
          </button>
          <button (click)="cropper?.fit()" ly-button [disabled]="!ready">Fit</button>
          <button (click)="cropper?.fitToScreen()" ly-button [disabled]="!ready">Fit to screen</button>
          <button (click)="cropper?.clean()" ly-button [disabled]="!ready">Clean</button>
        </div>
        <div [lyDisplay]="'flex'">
          <div [className]="classes.sliderContainer" class="d-flex">
            <ly-slider [disabled]="!ready" [thumbVisible]="false" [marks]="true" [color]="'#FC0D46'" [min]="minScale"
              [max]="maxScale" [(ngModel)]="scale" (input)="onSliderInput($event)" step="0.000001">
              <ly-mark [value]="minScale" (click)="scale=minScale">Min</ly-mark>
              <ly-mark [value]="maxScale" (click)="scale=maxScale">Max</ly-mark>
            </ly-slider>
          </div>
        </div>
      </div>
      <div class="mb-3 fw-bold">{{ t('cropper.crop.area') }} :</div>
      <div style="height: 240px;  max-width: 1296px; border: 1px solid #cccccc" class="mb-3 cursor-pointer">
        <ly-img-cropper [config]="myConfig" [(scale)]="scale" (minScale)="minScale = $event"
          (maxScale)="maxScale = $event" (ready)="ready = true" (cleaned)="ready = false" (cropped)="onCropped($event)"
          (loaded)="onLoaded($event)" (error)="onError($event)">
          <span>{{ t('cropper.drag.and.drop.image.to.resize.to') }} {{ cropAreaWidth }}x{{ cropAreaHeight }}px</span>
        </ly-img-cropper>
      </div>

      <div class="mb-3 fw-bold">{{ t('cropper.preview') }}:</div>
      <div style="height: 240px;  max-width: 1296px; background: lightgray"
        class="d-flex align-items-center justify-content-center">
        @if(croppedImage){
        <img [lyMaxWidth]="1" [src]="croppedImage">
        }
      </div>

      <div class="d-flex justify-content-between align-items-center bottom-action-bar py-4">
        <app-rounded-button [label]="t('app.common.cancel')" (onClick)="onDismissClick()"
                            [btnClass]="'rounded-button--black-outline'"></app-rounded-button>
        <div class="d-flex">
          <app-rounded-button [label]="t('cropper.select.file')" (onClick)="_fileInput.click()" [btnClass]="'me-3'">
            <ly-icon class="pe-2">
              image
            </ly-icon>
          </app-rounded-button>
          <!-- Hidden input -->
          <input #_fileInput type="file" (change)="cropper?.selectInputEvent($event)" accept="image/*" hidden>
          <app-rounded-button [label]="t('cropper.crop')" (onClick)="cropper?.crop()"
                              [isDisabled]="!ready" [btnClass]="'me-3'">
            <ly-icon class="pe-2">
              crop
            </ly-icon>
          </app-rounded-button>
          <app-rounded-button [label]="t('cropper.upload')" (onClick)="onConfirmClick()"
                              [isDisabled]="!croppedImage">
            <ly-icon class="pe-2">
              file_upload
            </ly-icon>
          </app-rounded-button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
